

























































































































































































import '@/extensions';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';

import {Component, Mixins, Prop} from 'vue-property-decorator';
import MultiSelect from "@/components/MultiSelect.vue";
import {SelectBox} from "@/interfaces/global-data";
import {
    AggregatedReportModalFilters, CreateAggregatedReportPayloadParams,
    EntityFilterKeys,
    EntityMaskOptions,
    TaskTypeEntityProperties
} from "@/pages/Sales/data";
import {GetTaskInfo, ProductInfoResponseProperty, TaskInfoFilterType, UserShortInfo} from "@/interfaces/server-data";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

@Component({
    computed: {
        TaskInfoFilterType() {
            return TaskInfoFilterType;
        }
    },
    components: {
        MultiSelect,
        DatePicker,
    },
})
export default class CreateAggregatedReportModal extends Mixins(LocalData, Http) {
    @Prop({required: true}) readonly isModalVisible!: boolean;
    @Prop({ default: () => [] }) readonly reportStatusOptions!: Array<SelectBox<string>>;

    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('shared.selectBox.all') as string}];

    modalFilters: AggregatedReportModalFilters = {
        groupIds: [],
        categoryIds: [],
        subcategoryIds: [],
        formatIds: [],
        regionIds: [],
        clusterIds: [],
        userIds: [0],
        dates: [],
        types: ['ALL'],
        statuses: ['ALL'],
        reportStatuses: ['ALL'],
    };

    modalFiltersOptions: EntityMaskOptions = {
        groups: [],
        categories: [],
        subcategories: [],
        formats: [],
        regions: [],
        clusters: [],
    };

    modalUsersOptions: Array<SelectBox<number>> = [{value: 0, label: this.$t('shared.selectBox.all') as string}];

    modalFilterOptionPropertyNames: TaskTypeEntityProperties = {
        group: 'groups',
        category: 'categories',
        subcategory: 'subcategories',
        format: 'formats',
        region: 'regions',
        cluster: 'clusters',
    }

    modalFiltersPropertyNames: TaskTypeEntityProperties = {
        group: 'groupIds',
        category: 'categoryIds',
        subcategory: 'subcategoryIds',
        format: 'formatIds',
        region: 'regionIds',
        cluster: 'clusterIds',
    }

    isCreateBtnLoading: boolean = false;

    mounted() {
        this.fetchModalSelectsOptions(TaskInfoFilterType.group, 'modalGroupsSelectRef');
        this.fetchModalSelectsOptions(TaskInfoFilterType.category, 'modalCategoriesSelectRef');
        this.fetchModalSelectsOptions(TaskInfoFilterType.subcategory, 'modalSubcategoriesSelectRef');
        this.fetchModalSelectsOptions(TaskInfoFilterType.format, 'modalFormatsSelectRef');
        this.fetchModalSelectsOptions(TaskInfoFilterType.region, 'modalRegionsSelectRef');
        this.fetchModalSelectsOptions(TaskInfoFilterType.cluster, 'modalClustersSelectRef');
        this.fetchModalUsersOptions();
    }

    fetchModalUsersOptions() {
        this.$nextTick(() => {
            if (this.$refs.modalUsersSelectRef) {
                (this.$refs.modalUsersSelectRef as any).toggleLoading(true);
            }
        });

        this.httpFetchUsersShortInfoList()
            .then((response) => {
                const users: UserShortInfo[] = response.data || [];
                const sortedOptions = users
                    .map((user) => ({
                        value: user.id,
                        label: (user.fio && user.fio.trim()) || user.username || `#${user.id}`,
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label));

                this.modalUsersOptions = [
                    {value: 0, label: this.$t('shared.selectBox.all') as string},
                    ...sortedOptions,
                ];
            })
            .catch(() => {
                this.modalUsersOptions = [{value: 0, label: this.$t('shared.selectBox.all') as string}];
                this.modalFilters.userIds = [0];

                this.showError(this.$t('shared.aggregatedReport.errorLoadUsers') as string);
            })
            .finally(() => {
                if (this.$refs.modalUsersSelectRef) {
                    (this.$refs.modalUsersSelectRef as any).toggleLoading(false);
                }
            });
    }

    handleModalUsersChanged(value: number[]) {
        if (!!value.length && !LocalData.compareTwoArrays(value, this.modalFilters.userIds)) {
            this.modalFilters.userIds = value.realValuesOrEmpty().length ? value : [0];
        }
    }

    closeModal() {
        this.$emit('close-modal');
    }

    hideModal() {
        this.$emit('hide-modal');
    }

    private get isCreateReportBtnDisabled() {
        return !this.modalFilters.dates.filter(date => !!date).length;
    }

    handleModalFiltersChanged(value: number[], type: EntityFilterKeys) {
        if (!!value.length && !LocalData.compareTwoArrays(value, this.modalFilters[this.modalFiltersPropertyNames[type] as keyof AggregatedReportModalFilters] as number[])) {
            this.modalFilters[this.modalFiltersPropertyNames[type] as keyof AggregatedReportModalFilters] = value.realValuesOrEmpty();

            this.updateModalFiltersData(type);
        }
    }

    handleModalParamMultiselectValueChanged(value: string[], key: 'statuses' | 'types' | 'reportStatuses', optionsWithoutAllLength: number = 0) {
        if (!!value.length) {
            if ((value.length === 1 && value[0] === 'ALL') || value[value.length - 1] === 'ALL') {
                this.modalFilters[key] = ['ALL'];
            } else {
                const arrRes = value.filter(value => value !== 'ALL');

                if (arrRes.length === optionsWithoutAllLength) {
                    this.modalFilters[key] = ['ALL'];
                } else {
                    this.modalFilters[key] = arrRes;
                }
            }
        } else {
            this.modalFilters[key] = ['ALL'];
        }
    }

    private getLoadOptionsFilter(taskType: EntityFilterKeys): GetTaskInfo {
        switch (taskType) {
            case TaskInfoFilterType.group:
                return {
                    type: taskType,
                    tradingId: this.$sales.selectMarket.id,
                    groups: [],
                    categories: [],
                    subcategory: [],
                    storeFormat: [],
                    storeRegion: [],
                    storeCluster: [],
                    productSegments: null,
                    segments: null,
                    byReports: false,
                };
            case TaskInfoFilterType.category:
                return {
                    type: taskType,
                    tradingId: this.$sales.selectMarket.id,
                    groups: this.modalFilters.groupIds.realValuesOrEmpty(),
                    categories: [],
                    subcategory: [],
                    storeFormat: [],
                    storeRegion: [],
                    storeCluster: [],
                    productSegments: null,
                    segments: null,
                    byReports: false,
                };
            case TaskInfoFilterType.subcategory:
                return {
                    type: taskType,
                    tradingId: this.$sales.selectMarket.id,
                    groups: this.modalFilters.groupIds.realValuesOrEmpty(),
                    categories: this.modalFilters.categoryIds.realValuesOrEmpty(),
                    subcategory: [],
                    storeFormat: [],
                    storeRegion: [],
                    storeCluster: [],
                    productSegments: null,
                    segments: null,
                    byReports: false,
                };
            case TaskInfoFilterType.format:
                return {
                    type: taskType,
                    tradingId: this.$sales.selectMarket.id,
                    groups: [],
                    categories: [],
                    subcategory: [],
                    storeFormat: [],
                    storeRegion: [],
                    storeCluster: [],
                    productSegments: null,
                    segments: null,
                    byReports: false,
                };
            case TaskInfoFilterType.region:
                return {
                    type: taskType,
                    tradingId: this.$sales.selectMarket.id,
                    groups: [],
                    categories: [],
                    subcategory: [],
                    storeFormat: this.modalFilters.formatIds.realValuesOrEmpty(),
                    storeRegion: [],
                    storeCluster: [],
                    productSegments: null,
                    segments: null,
                    byReports: false,
                };
            case TaskInfoFilterType.cluster:
                return {
                    type: taskType,
                    tradingId: this.$sales.selectMarket.id,
                    groups: [],
                    categories: [],
                    subcategory: [],
                    storeFormat: this.modalFilters.formatIds.realValuesOrEmpty(),
                    storeRegion: this.modalFilters.regionIds.realValuesOrEmpty(),
                    storeCluster: [],
                    productSegments: null,
                    segments: null,
                    byReports: false,
                };
        }
    }

    fetchModalSelectsOptions(type: EntityFilterKeys, refValue: string) {
        this.$nextTick(() => {
            if (this.$refs[refValue]) {
                (this.$refs[refValue] as any).toggleLoading(true);
            }
        });

        this.httpGetProductInfo(this.getLoadOptionsFilter(type))
            .then(data => {
                const options = data.data ? data.data[ProductInfoResponseProperty[type]] : [];

                if (options.length) {
                    this.modalFiltersOptions[this.modalFilterOptionPropertyNames[type] as keyof EntityMaskOptions] = [
                        { value: 0, label: this.$t('shared.selectBox.all') as string },
                        ...options.map((i) => {
                            return { value: i.id, label: i.name };
                        }),
                    ];
                } else {
                    this.modalFiltersOptions[this.modalFilterOptionPropertyNames[type] as keyof EntityMaskOptions] = [{ value: 0, label: this.$t('shared.selectBox.all') as string }];
                }
            })
            .catch(() => {
                this.modalFiltersOptions[this.modalFilterOptionPropertyNames[type] as keyof EntityMaskOptions] = [{ value: 0, label: this.$t('shared.selectBox.all') as string }];

                this.showError(this.$t('shared.aggregatedReport.errorLoadOptions') as string);
            }).finally(() => {
            if (this.$refs[refValue]) {
                (this.$refs[refValue] as any).toggleLoading(false);
            }
        });
    }

    updateModalFiltersData(type: EntityFilterKeys) {
        const defaultMultiSelectValue: number[] = this.defaultIntSelectBox.map(i => i.value);

        switch (type) {
            case TaskInfoFilterType.group:
                this.fetchModalSelectsOptions(TaskInfoFilterType.category, 'modalCategoriesSelectRef');
                this.modalFilters.categoryIds = [...defaultMultiSelectValue];

                this.fetchModalSelectsOptions(TaskInfoFilterType.subcategory, 'modalSubcategoriesSelectRef');
                this.modalFilters.subcategoryIds = [...defaultMultiSelectValue];

                break;
            case TaskInfoFilterType.category:
                this.fetchModalSelectsOptions(TaskInfoFilterType.subcategory, 'modalSubcategoriesSelectRef');
                this.modalFilters.subcategoryIds = [...defaultMultiSelectValue];

                break;
            case TaskInfoFilterType.format:
                this.fetchModalSelectsOptions(TaskInfoFilterType.region, 'modalRegionsSelectRef');
                this.modalFilters.regionIds = [...defaultMultiSelectValue];

                this.fetchModalSelectsOptions(TaskInfoFilterType.cluster, 'modalClustersSelectRef');
                this.modalFilters.clusterIds = [...defaultMultiSelectValue];

                break;
            case TaskInfoFilterType.region:
                this.fetchModalSelectsOptions(TaskInfoFilterType.cluster, 'modalClustersSelectRef');
                this.modalFilters.clusterIds = [...defaultMultiSelectValue];

                break;
        }
    }

    private filterAllValue(values: string[]): string[] {
        return values.includes('ALL') ? [] : values;
    }

    handleCreateReport() {
        this.isCreateBtnLoading = true;

        const aggregatedReportPayloadParams: CreateAggregatedReportPayloadParams = {
            tradingId: this.$sales.selectMarket.id,
            groups: this.modalFilters.groupIds.realValuesOrEmpty(),
            categories: this.modalFilters.categoryIds.realValuesOrEmpty(),
            subcategories: this.modalFilters.subcategoryIds.realValuesOrEmpty(),
            storeFormats: this.modalFilters.formatIds.realValuesOrEmpty(),
            storeRegions: this.modalFilters.regionIds.realValuesOrEmpty(),
            storeClusters: this.modalFilters.clusterIds.realValuesOrEmpty(),
            userIds: this.modalFilters.userIds.realValuesOrEmpty(),
            startDate: this.modalFilters.dates[0],
            endDate: this.modalFilters.dates[1],
            saleTypes: this.filterAllValue(this.modalFilters.types),
            saleStatuses: this.filterAllValue(this.modalFilters.statuses),
            resultStatus: this.filterAllValue(this.modalFilters.reportStatuses),
        };

        this.httpSalesCreateAggregatedReport(aggregatedReportPayloadParams)
            .then(() => {
                this.showInfo(this.$t('shared.aggregatedReport.successStartReport') as string, 5);

                this.closeModal();
            }).catch(() => {
                this.showError(this.$t('shared.aggregatedReport.errorStartReport') as string);
            }).finally(() => {
                this.isCreateBtnLoading = false;
            });
    }
}
